import { DRAG_MODE, type MouseEventConfig } from "@niivue/niivue"

export type ViewerMouseMode = "pointer" | "windowLevel" | "zoom" | "pan"

export const DEFAULT_VIEWER_MOUSE_MODE: ViewerMouseMode = "pointer"

const DRAG_MODE_BY_MOUSE_MODE: Record<ViewerMouseMode, DRAG_MODE> = {
  pointer: DRAG_MODE.crosshair,
  windowLevel: DRAG_MODE.windowing,
  zoom: DRAG_MODE.slicer3D,
  pan: DRAG_MODE.pan
}

export function getDragModeForViewerMouseMode(mode: ViewerMouseMode): DRAG_MODE {
  return DRAG_MODE_BY_MOUSE_MODE[mode]
}

export function buildMouseEventConfig(mode: ViewerMouseMode): MouseEventConfig {
  return {
    leftButton: {
      primary: getDragModeForViewerMouseMode(mode)
    },
    rightButton: DRAG_MODE.contrast,
    centerButton: DRAG_MODE.pan
  }
}

export function buildSamMouseEventConfig(): MouseEventConfig {
  return {
    leftButton: { primary: DRAG_MODE.callbackOnly },
    rightButton: DRAG_MODE.contrast,
    centerButton: DRAG_MODE.pan
  }
}
